import React from "react";

const Engagement = () => {
  return (
    <>
      {" "}
      <div className="tab-content-section">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="mb-0">Engagement Rate</h4>
          <a href="#">
            <i className="ri-question-line text-muted"></i>
          </a>
        </div>

        <div className="col-md-6 mb-4">
          <div className="p-4 border rounded d-flex align-items-center gap-3">
            <i className="ri-bar-chart-grouped-line fs-1 text-warning"></i>
            <div>
              <h2 className="mb-0 text-warning">0.08%</h2>
              <p className="mb-0">Engagement Rate</p>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="p-4 border rounded">
            <div id="engagementBarChart" style={{ height: "350px" }}></div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Comments</h5>
              </div>
              <div id="commentsScatter" style={{ height: "300px" }}></div>
              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-2 view-more-btn"
                data-bs-toggle="modal"
                data-bs-target="#engagementModal"
              >
                VIEW MORE
              </a>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Likes</h5>
              </div>
              <div id="likesScatter" style={{ height: "300px" }}></div>
              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-2 view-more-btn"
                data-bs-toggle="modal"
                data-bs-target="#engagementModal"
              >
                VIEW MORE
              </a>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Popular #</h5>
                <a href="#">
                  <i className="ri-question-line text-muted"></i>
                </a>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>#financialadda</span>
                  <span>34.88%</span>
                </div>
                <div className="progress mt-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "34.88%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>#jassfinance</span>
                  <span>17.44%</span>
                </div>
                <div className="progress mt-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "17.44%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>#stockmarketindia</span>
                  <span>13.37%</span>
                </div>
                <div className="progress mt-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "13.37%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>#ipo</span>
                  <span>12.79%</span>
                </div>
                <div className="progress mt-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "12.79%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>#ipoalert</span>
                  <span>12.21%</span>
                </div>
                <div className="progress mt-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "12.21%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>#askiratsinghgujral</span>
                  <span>9.88%</span>
                </div>
                <div className="progress mt-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-primary"
                    style={{ width: "9.88%" }}
                  ></div>
                </div>
              </div>

              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-2"
              >
                VIEW MORE
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Engagement;
